window.MTGGoldfishMetagame = window.MTGGoldfishMetagame || {};

window.MTGGoldfishMetagame.onDocumentReady = function() {

  var currentPrice;
  var priceToShow;

  function setToggle(selector, show) {
    document.querySelectorAll(selector).forEach(function(el) {
      if (!show) {
        el.style.display = 'none';
      } else if (el.tagName === 'SPAN') {
        el.style.display = 'inline';
      } else {
        el.style.display = 'block';
      }
    });
  }

  var showTab = function(preference) {
    console.log("Metagame showTab");
    document.querySelectorAll('.type-switcher-tabs > li > a').forEach(function(el) {
      var href = el.getAttribute("href") || '';
      if (href.match("tab-" + preference)) {
        bootstrap.Tab.getOrCreateInstance(el).show();
      }
    });

    if (!["paper", "online", "arena"].includes(preference)) {
      if (!currentPrice) currentPrice = getDefaultPreference();
      priceToShow = currentPrice;
    } else {
      priceToShow = preference;
      currentPrice = preference;
    }

    if (priceToShow === 'paper') {
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-paper", true);
      setToggle(".deck-price-arena", false);
    } else if (priceToShow === 'online') {
      setToggle(".deck-price-online", true);
      setToggle(".deck-price-paper", false);
      setToggle(".deck-price-arena", false);
    } else if (priceToShow === 'arena') {
      setToggle(".deck-price-arena", true);
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-paper", false);
    }
  }

  document.addEventListener('click', function(e) {
    if (!e.target) return;
    var link = e.target.closest('.deck-container-main .type-switcher-tabs a');
    if (!link) return;
    if (!link.classList.contains("regular-link")) {
      e.preventDefault();
      bootstrap.Tab.getOrCreateInstance(link).show();
      var href = link.getAttribute('href') || '';
      var target = "#online";
      if (href.match("tab-paper")) target = '#paper';
      else if (href.match("tab-online")) target = '#online';
      else if (href.match("tab-arena")) target = '#arena';
      else return;

      if (history.pushState) history.pushState(null, null, target);
      else window.location.hash = target;
    }
  });

  document.addEventListener('shown.bs.tab', function(e) {
    var tabEl = e.target;
    var container = tabEl.closest('.deck-container-main');
    if (!container || !tabEl.matches('[data-bs-toggle="tab"]')) return;

    var dropdownTarget = container.querySelector(".type-switcher-tabs .deck-type-dropdown-menu .nav-link");
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget || '';
    var dropdownClazz = hash.replace(/#.*tab-/, "");
    var dropdownClazzLabelText = tabEl.textContent.trim();

    if (dropdownTarget) updateDropdownTypeToggle(dropdownTarget, dropdownClazz, dropdownClazzLabelText);

    var href = tabEl.getAttribute('href') || '';
    if (href.match('tab-paper')) {
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-paper", true);
      setToggle(".deck-price-arena", false);
    } else if (href.match('tab-online')) {
      setToggle(".deck-price-online", true);
      setToggle(".deck-price-paper", false);
      setToggle(".deck-price-arena", false);
    } else if (href.match('tab-arena')) {
      setToggle(".deck-price-arena", true);
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-paper", false);
    }
  });

  // Initialize based on URL hash or cookie
  var url = document.location.toString();
  if (url.match('#')) {
    showTab(url.split('#')[1]);
  } else {
    var preference = getDefaultPreference();
    history.replaceState(null, null, '#' + preference);
    showTab(preference);
  }

  function getDefaultPreference() {
    var preference = Cookies.get('type-preference');
    if (preference === "online" || preference === "arena") return preference;
    return "paper";
  }

  window.addEventListener("popstate", function(e) {
    var popUrl = document.location.toString();
    if (popUrl.match('#')) showTab(popUrl.split('#')[1]);
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest('#deck-like-btn')) return;
    var btn = e.target.closest('#deck-like-btn');
    btn.disabled = true;
    var id = btn.dataset.id;
    var action = btn.dataset.action;
    var logged = btn.dataset.logged;
    if (logged) {
      var token = document.querySelector('meta[name="csrf-token"]').content;
      fetch('/deck/vote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': token
        },
        body: new URLSearchParams({ id: id, vote: action }),
        credentials: 'same-origin'
      });
    } else {
      bootstrap.Modal.getOrCreateInstance(document.querySelector('#login-modal')).show();
    }
  });
};
